export const communicateConfig = {
    title: '感知觉与沟通评估表',
    explain: (
        <div>
            <div>能力完好：意识清醒，且听力和视力评为0或1，沟通评为0，总分0-2分;</div>
            <div>轻度受损：意识清醒，但视力或听力中至少一项评为2，或沟通评为1，总分3-5分;</div>
            <div>
                中度受损：意识清醒，但视力或听力中至少一项评为3，或沟通评为2；或嗜睡，视力或听力评定为3及以下，沟通评定为2及以下，总分6-10;
            </div>
            <div>
                重度受损：意识清醒或嗜睡，但视力或听力中至少一项评为4，或沟通评为3；或昏睡/昏迷，总分11-14分
            </div>
        </div>
    ),
    result: totleScore => {
        let result = '';
        switch (true) {
            case totleScore <= 2 && totleScore >= 0:
                result = '能力完好';
                break;
            case totleScore <= 5 && totleScore >= 3:
                result = '轻度受损';
                break;
            case totleScore <= 10 && totleScore >= 6:
                result = '中度受损';
                break;
            default:
                result = '重度受损';
                break;
        }
        return result;
    },
    qus: [
        {
            title: '意识水平：',
            options: [
                { label: '神志清醒，对周围环境警觉', score: 0 },
                {
                    label: '嗜睡，表现为睡眠状态过渡延长。当呼唤或推动患者的肢体时可唤醒，并能进行正确的交谈或执行指令，停止刺激后又继续入睡',
                    score: 1,
                },
                {
                    label: '昏睡，一般的外界刺激不能使其觉醒，给与较强烈的刺激时可有短时的意识清醒，醒后可简短回答提问，当刺激减弱后又很快进入睡眠状态',
                    score: 2,
                },
                {
                    label: '昏迷，处于浅昏迷时对疼痛刺激有回避和痛苦表情；处于深昏迷时对刺激无反应（若评定为昏迷，直接评定为重度失能，可不进行以下项目的评估）',
                    score: 3,
                },
            ],
        },
        {
            title: '视力：若平日带老花镜或近视镜，应在佩戴眼镜的情况下评估',
            options: [
                { label: '能看清楚书报上的标准字体', score: 0 },
                { label: '能看清楚大字体，但看不清楚书报上的标准字体', score: 1 },
                { label: '视力有限，看不清楚报纸大标题，但能辨认物体', score: 2 },
                { label: '辨认物体有困难，但眼睛能跟随物体移动，只能看到光、颜色和形状', score: 3 },
                { label: '没有视力，眼睛不能跟随物体移动', score: 4 },
            ],
        },
        {
            title: '听力：若平时佩戴助听器，应在佩戴助听器的情况下评估',
            options: [
                { label: '可正常交谈，能听到电视、电话、门铃的声音', score: 0 },
                { label: '在轻声说话或说话距离超过2米时听不清', score: 1 },
                { label: '正常交流有些困难，需在安静的环境或大声说话才能听到', score: 2 },
                { label: '讲话者大声说话或说话很慢，才能部分听见', score: 3 },
                { label: '完全听不见', score: 4 },
            ],
        },
        {
            title: '沟通交流：包括非语言沟通',
            options: [
                { label: '无困难，能与他人正常沟通和交流', score: 0 },
                { label: '能够表达自己的需要及理解别人的话，但需要增加时间或给予帮助', score: 1 },
                { label: '表达需要或理解有困难，需频繁重复或简化口头表达', score: 2 },
                { label: '不能表达需要或理解他人的话', score: 3 },
            ],
        },
    ],
};
